import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Grid, Loader, Segment } from 'semantic-ui-react';
import { ClassProp } from 'helpers/types';

type Props = {
  loading: boolean;
  classes: ClassProp<typeof styles>;
};

const styles = {
  grid: {
    background: 'rgba(0, 0, 0, .3)',
    bottom: 0,
    color: '#fff',
    height: '100%',
    margin: '0 !important',
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 10000,
  },
  segment: {
    background: 'transparent !important',
    border: '0 !important',
    boxShadow: 'none !important',
  },
};

const Loading: FunctionComponent<Props> = ({ classes, loading }) => {
  const renderWithLoading = () => {
    if (!loading) {
      return null;
    }

    return (
      <Grid className={classes.grid} centered>
        <Grid.Row columns={3} verticalAlign="middle">
          <Grid.Column>
            <Segment className={classes.segment}>
              <Loader active inline="centered" size="massive" />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  return renderWithLoading();
};

export default withStyles(styles)(Loading);
